import WeAre from './WeAre';
export default WeAre;
